import React from 'react';
import PropTypes from 'prop-types';
import { Col, ListGroup, ListGroupItem, Row } from "reactstrap";
import * as Feather from 'react-feather';

const FileResume = (props) => {
  const { files } = props;

  const STATUS_MAPPER = {
    processing: 'primary',
    success: 'success',
    failure: 'danger',
    queued: ''
  };

  const ICON_MAPPER = {
    success: 'Check',
    failure: 'X',
  };

  const renderItemInfo = (file) => {
    const iconName = ICON_MAPPER[file.status];
    const Icon = iconName ? Feather[iconName] : null;
    return (
      <div className="upload-list-action">
        { file.status === 'processing' ? <span>{file.uploadPercent || 0}%</span> : null }
        { Icon ? <Icon /> : null }
      </div>
    );
  };

  return (
    <Row>
      <Col xs="12">
        <div className="import-file-resume">
          <ListGroup>
            {
              files.map(file => {
                return (
                  <ListGroupItem key={file.order} color={STATUS_MAPPER[file.status]}>
                    { file.name }
                    { renderItemInfo(file)}
                  </ListGroupItem>
                );
              })
            }
          </ListGroup>
        </div>
      </Col>
    </Row>
  );
};

FileResume.propTypes = {
  files: PropTypes.array.isRequired
};

export default FileResume;